import axios from 'axios';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import {
  calculateTenderOpeningStatus,
  unwrapProcurement,
} from '../utils/tenderOpeningHelpers';

const COMPLETION_PUT_PAYLOAD = {
  isRequestHpsCompleted: {
    isRequestHpsCompleted: true,
  },
  isInviteDMUTCompleted: {
    isInviteDMUTCompleted: true,
  },
  isInvitePanitiaTenderCompleted: {
    isInvitePanitiaTenderCompleted: true,
  },
  isReqFreightAvailabilityCompleted: {
    isReqFreightAvailabilityCompleted: true,
  },
};

export const fetchProcurementRaw = async procId => {
  const token = getAuthToken();
  if (!token) return null;

  try {
    const response = await axios.get(`${api.API_URL}/procurement/${procId}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    return unwrapProcurement(response);
  } catch {
    return null;
  }
};

const buildProcurementWithCompletion = (procurement, completionField) => ({
  ...procurement,
  [completionField]: true,
});

export const updateTenderOpeningStatus = async (
  procId,
  completionField,
  { maxRetries = 1, delayMs = 1000 } = {}
) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Authentication required. Please login again.');
  }

  const completionPayload = COMPLETION_PUT_PAYLOAD[completionField];
  if (!completionPayload) {
    throw new Error(`Unsupported completion field: ${completionField}`);
  }

  let lastError;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const procurement = await fetchProcurementRaw(procId);
      if (!procurement) {
        throw new Error('Failed to load procurement data.');
      }

      const procurementWithCompletion = buildProcurementWithCompletion(
        procurement,
        completionField
      );
      const statusUpdate = calculateTenderOpeningStatus(
        procurementWithCompletion
      );

      const payload = {
        ...completionPayload,
        tenderOpeningStatus: statusUpdate.tenderOpeningStatus,
      };

      if (statusUpdate.submittedDateTenderOpening) {
        payload.submittedDateTenderOpening =
          statusUpdate.submittedDateTenderOpening;
      }

      await axios.put(
        `${api.API_URL}/procurement/update-tender-opening/${procId}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return statusUpdate;
    } catch (error) {
      lastError = error;
      if (attempt < maxRetries) {
        await new Promise(resolve => setTimeout(resolve, delayMs * attempt));
      }
    }
  }

  const message =
    lastError?.response?.data?.message ||
    lastError?.message ||
    'Failed to update tender opening status.';

  throw new Error(message);
};
